import React, { useState, useCallback, useContext, useEffect} from 'react'
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close"
import { Dialog, Button, CircularProgress, Checkbox } from '@mui/material'
import { LabelInput } from '../../../../components/LabelInput'
import SelectInput from '../../../../components/SelectInput';
import { formatPhone, isPhone, isEmail, formatCPF, formatDate, formatDateToISOZulu, isValidDate, isValidCPF, formatPhoneToFront, formatBirthdateToFront} from '../../../../utils/utils'
import { v4 as uuidv4 } from 'uuid'
import { Radio } from '@mui/material';
import { RadioGroup } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import axios from 'axios'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import * as S from "../../styles"
import AuthContext from "../../../../context/auth-context"
import SearchBar from "../../SearchBar"
import { DataField } from "../../../../components/DataField"
import ContactsIcon from '@mui/icons-material/Contacts';
import { Pagination } from "@mui/material";
import { ErrorPage } from "../../../AuxiliarPages/ErrorPage/ErrorPage"

function SignerCreationDialog(props) {
    const { open, setOpen, handleToast, envelopeData } = props

    const [loading, setLoading] = useState(false)
    const company_key = useContext(AuthContext).user_data.company_key

    const [openDemoRequestModal, setOpenDemoRequestModal] = useState(false)

    const closeDemoRequestModal = () => {
        setOpenDemoRequestModal(false);
    };
    
    const primaryColor = "#0b1f82"

    const singatureRoleOptions = [
        { value: 'others', description: 'Outros / Não definir' },
        { value: 'signer', description: "Assinante"},
        { value: 'party', description: 'Parte' },
        { value: 'witness', description: 'Testemunha' },
        { value: 'contractor', description: 'Contratante' },
        { value: 'contracted', description: 'Contratado' },
        { value: 'transferor', description: 'Cedente' },
        { value: 'transferee', description: 'Cessionário' },
        { value: 'manager', description: 'Administrador' },
        { value: 'attorney', description: 'Procurador' },
        { value: 'legal_representative', description: 'Representante legal' },
        { value: 'legal_responsible', description: 'Responsável legal' },
        { value: 'lawyer', description: 'Advogado' },
        { value: 'validator', description: 'Validador' },
        { value: 'intervening_party', description: 'Interveniente' },
        { value: 'shareholder', description: 'Cotista' },
    ];

    const minorboxStyles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        boxShadow: 24,
        height: 300,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };

    const [touched, setTouched] = useState({
        subject: false,
        expiration_date: false,
        name: false,
        birthdate: false,
        document_number: false,
        email: false,
        phone: false,
        document_submission_method: false,
        authentication_submission_method: false,
    })

    const errorMessages = {
        phone: "Telefone inválido",
        email: "Email inválido",
        subject: "Assunto é obrigatório",
        expiration_date: "Data de expiração inválida",
        name: "Nome é obrigatório",
        birthdate: "Data de nascimento inválida",
        document_number: "CPF inválido",
        document_submission_method: "Método de envio dos documentos é obrigatório",
        authentication_submission_method: "Método de envio do código de autenticação é obrigatório"
    }

    const [signers, setSigners] = useState([])

    const [authenticationSubmissionErrors, setAuthenticationSubmissionErrors] = useState(Array(signers.length).fill(false));
    const [documentSubmissionErrors, setDocumentSubmissionErrors] = useState(Array(signers.length).fill(false));

    const handleSignerBlur = (index, id, value) => {
        setSigners([
            ...signers.slice(0, index),
            {
                ...signers[index],
                [id]: value
            },
            ...signers.slice(index + 1)
        ])
        setTouched((prevTouched) => ({
            ...prevTouched,
            [id]: true,
        }))
    }

    const [values, setValues] = useState({
        signers: signers
    })

    const resetForm = () => {
        setValues({
            subject: "",
            expiration_date: "",
            signers: [
                {
                    name: "",
                    birthdate: "",
                    document_number: "",
                    email: "",
                    phone: "",
                    document_submission_method: "",
                    authentication_submission_method: "",
                    document_number_required: true
                }
            ]
        })
        setSigners([
            {
                name: "",
                birthdate: "",
                document_number: "",
                email: "",
                phone: "",
                document_submission_method: "",
                authentication_submission_method: "",
                document_number_required: true
            }
        ])
    }
    const validateForm = () => {
        const allValues = {
            ...values,
            signers: signers
        }

        const newDocumentSubmissionErrors = [...documentSubmissionErrors];
        const newAuthenticationSubmissionErrors = [...authenticationSubmissionErrors];

        signers.forEach((signer, index) => {
            if (!signer.document_submission_method){
                newDocumentSubmissionErrors[index] = true 
            }

            if (!signer.authentication_submission_method){
                newAuthenticationSubmissionErrors[index] = true 
            }
        })

        setDocumentSubmissionErrors(newDocumentSubmissionErrors)
        setAuthenticationSubmissionErrors(newAuthenticationSubmissionErrors)

        const allTouched = {
            ...touched,
            subject: true,
            name: true,
            birthdate: true,
            document_number: true,
            email: true,
            phone: true,
            document_submission_method: true,
            authentication_submission_method: true
        }

        setTouched(allTouched)

        const areSignersValid = Object.keys(allValues).every((key) => {
            if (key === "signers") {
                return values[key].every((signer) => {

                    if ((signer.authentication_submission_method === "email" || signer.document_submission_method === "email") && signer.email === "") {
                        return false
                    }

                    if ((signer.authentication_submission_method === "whatsapp" || signer.document_submission_method === "whatsapp") && signer.phone === "") {
                        return false
                    }

                    if ((signer.authentication_submission_method === "sms" || signer.document_submission_method === "sms") && signer.phone === "") {
                        return false
                    }

                    if (signer.document_number_required === true && signer.document_number === "") {
                        return false
                    }
        
                    return Object.keys(signer).every((signerKey) => {
                        return validateInput[signerKey](signer[signerKey])
                    })
                })
            }

            return validateInput[key](values[key])
        })

        return areSignersValid
    }
    
    const validateInput = {
        phone: (value) => {
            return value === "" || isPhone(value);
        },
        email: (value) => { 
            return value === "" || isEmail(value)
        },
        name: (value) => value !== "",
        birthdate: (value) => {
            return value === "" || isValidDate(value);
        },
        document_number: (value) =>  {
            return value === "" || isValidCPF(value)
        },
        document_submission_method: (value) => value !== "",
        authentication_submission_method: (value) => value !== "",
        document_number_required: (value) => {
            return value === true || value === false
        },
        signature_role: (value) => true
    }

    const handleInputChange = (index, field, value) => {
        const updatedSigners = [...signers]
        updatedSigners[index][field] = value
        setSigners(updatedSigners)
        const updatedValues = { ...values }
        updatedValues.signers = updatedSigners
        setValues(updatedValues)
    }

    const openContactGroupSelection = () => {
        setOpenContactGroupDialog(true)
    }
    
    const [filterContactGroupContent, setFilterContactGroupContent] = useState("");
    const [refresherContactGroup, setRefresherContactGroup] = useState(false);
    
    const handleContactGroupSearch = (queryParameter) => {
        setSearchContactGroup(queryParameter)
    };

    const validateContactData = () => {
        if(newSignerContact?.name?.length === 0){
            handleToast('Preencha o nome para salvar assinante na agenda', 'warning')
            return false
        }

        if(newSignerContact?.email?.length === 0){
            handleToast('Preencha o email para salvar assinante na agenda', 'warning')
            return false
        }
        
        if(newSignerContact?.document_number?.length === 0){
            handleToast('Preencha o CPF corretamente para salvar assinante na agenda', 'warning')
            return false
        }

        if(newSignerContact?.document_submission_method?.length === 0){
            handleToast('Selecione pelo menos um método de envio para salvar assinante na agenda', 'warning')
            return false
        }
        if(newSignerContact?.authentication_submission_method?.length === 0){
            handleToast('Selecione pelo menos um método de autentificação para salvar assinante na agenda', 'warning')
            return false
        }

        return true
    }


    const handleContactGroup = (contactGroup) => {
        if(newSignerContact){
            const contactGroupKey = contactGroup.contact_group_key
            if(!validateContactData()) return
            let rawContactData = {}
            const digitPhone = newSignerContact.phone.replace(/\D/g, '')
            if ((digitPhone || '').length > 0){
                const phoneData = {
                    international_dial_code: '55',
                    area_code: digitPhone.substring(0, 2),
                    number: digitPhone.substring(2, 11)
                }

                rawContactData = {
                    name: newSignerContact.name,
                    email: newSignerContact.email,
                    document_number: newSignerContact.document_number,
                    phone: phoneData,
                    document_submission_method: newSignerContact.document_submission_method,
                    authentication_submission_method: newSignerContact.authentication_submission_method
                }

            } else {

                rawContactData = {
                    name: newSignerContact.name,
                    email: newSignerContact.email,
                    document_number: newSignerContact.document_number,
                    document_submission_method: newSignerContact.document_submission_method,
                    authentication_submission_method: newSignerContact.authentication_submission_method
                }
            }

            const createContactPayload = {
                contact_name: newSignerContact.name,
                contact_data: rawContactData
            }

            setLoading(true)
            axios
            .post(`/dash/sign/company/${company_key}/contact_group/${contactGroupKey}/contact`, createContactPayload)
            .then((response) => {
                handleToast(`Assinante ${response?.data?.contact_name} foi adicionado`, 'success')
                resetNewSignerContactForm()
            })
            .catch((error) => {
                console.error(error)
                handleToast(`Erro ao tentar salvar assinante`, 'error')
            }).finally(()=> {
                setLoading(false)    
            })
        } else {
            setContactGroupSelected(contactGroup)
            setOpenContactSelectionDialog(true)
        }
    };
    
    const [searchContactGroup, setSearchContactGroup] = useState("");
    const [openContactGroupDialog, setOpenContactGroupDialog] = useState(false)
    const [contactGroupsData, setContactGroupsData] = useState(undefined)
    const [currentContactGroupPage, setCurrentContactGroupPage] = useState(1)
    const [maxContactGroupPage, setMaxContactGroupPage] = useState(1)
    const [contactGroupSelected, setContactGroupSelected] = useState(undefined)
    const [contactsLoading, setContactsLoading] = useState(false)

    const [configContactGroups, setConfigContactGroups] = useState({
        params: {
            page_number: 0,
            page_rows: 7
        }
    })
    
    const [searchContact, setSearchContact] = useState("");
    const [openContactSelectionDialog, setOpenContactSelectionDialog] = useState(false)
    const [filterContactContent, setFilterContactContent] = useState("");
    const [refresherContact, setRefresherContact] = useState(false);
    const [contactsData, setContactsData] = useState(undefined)
    const [maxContactPage, setMaxContactPage] = useState(1)
    const [currentContactPage, setCurrentContactPage] = useState(1)

    const handleContactSearch = (queryParameter) => {
        setSearchContact(queryParameter)
    };

    const [configContacts, setConfigContacts] = useState({
        params: {
            page_number: 0,
            page_rows: 5
        }
    })

    const [selectedContacts, setSelectedContacts] = useState([]);
    
    const handleCheckboxChange = (contact) => {
        setSelectedContacts((prevSelected) =>
            prevSelected.some((selectedContact) => selectedContact.contact_key === contact.contact_key)
                ? prevSelected.filter((selectedContact) => selectedContact.contact_key !== contact.contact_key)
                : [...prevSelected, contact]
        );
    };

    const verifyContactOnCheckbox = (contact_key) => {
        for (let i = 0; i < selectedContacts.length; i++) {
            if (selectedContacts[i].contact_key === contact_key) {
                return true;
            }
        }
        return false;
    };

    const handleContactsSelect = () => {
        handleAddSignerFromContacts()
    };

    const [error, setError] = useState({
        hasError: false,
        statusCode: 200
    })

    const requestContactGroups = useCallback(() => {
        const queryString = `${searchContactGroup ? `${searchContactGroup}&` : '?'}page_number=${configContactGroups.params.page_number}&page_rows=${configContactGroups.params.page_rows}`;
        axios.get(`/dash/sign/company/${company_key}/contact_groups${queryString}`)
        .then((response) => {
            setContactGroupsData(response.data)
            setMaxContactGroupPage(response.data.pagination.number_of_pages)
        })
        .catch((error) => {
            setError({
                "has_error": true,
                "status": error.response.status
            })
        })
    }, [configContactGroups, company_key, searchContactGroup]);
        

    const requestContacts = useCallback(() => {
        const queryString = `${searchContact ? `${searchContact}&` : '?'}page_number=${configContacts.params.page_number}&page_rows=${configContacts.params.page_rows}`;

        axios.get(`/dash/sign/company/${company_key}/contact_group/${contactGroupSelected.contact_group_key}/contacts${queryString}`)
        .then((response) => {
            setContactsData(response.data)
            setMaxContactPage(response.data.pagination.number_of_pages)
        })
        .catch((error) => {
            setError({
                "has_error": true,
                "status": error.response.status
            })
        })
        .finally(() => {
            setContactsLoading(false)
        })
    }, [configContacts, company_key, contactGroupSelected, searchContact])


    const handleContacts = () => {
        openContactGroupSelection()
        requestContactGroups()
    }

    const handleAddSignerFromContacts = () => {
        const updatedSigners = [...signers];
    
        for (const contact of selectedContacts) {
            const newSigner = {
                name: contact.contact_data.name, 
                birthdate: formatBirthdateToFront(contact.contact_data.birthdate), 
                document_number: contact.contact_data.document_number,
                email: contact.contact_data.email || "", 
                phone: formatPhoneToFront(contact.contact_data.phone), 
                document_submission_method: contact.contact_data.document_submission_method ,
                authentication_submission_method: contact.contact_data.authentication_submission_method,
                document_number_required: true
            };
    
            updatedSigners.push(newSigner);
        }
    
        setSigners(updatedSigners);
        clearSelectedContacts();
    };
    
    useEffect(() => {
        let newConfigContactGroup;
        newConfigContactGroup = configContactGroups;
        newConfigContactGroup.params.page_number = currentContactGroupPage - 1;
        setConfigContactGroups(newConfigContactGroup);
        requestContactGroups();
      }, [currentContactGroupPage, configContactGroups, requestContactGroups]);


    useEffect(() => {
        let newConfigContact;
        newConfigContact = configContacts;
        newConfigContact.params.page_number = currentContactPage - 1;
        setConfigContacts(newConfigContact);

        if (contactGroupSelected) {
            setContactsLoading(true)
            requestContacts();
        }

      }, [currentContactPage, configContacts, contactGroupSelected, requestContacts]);

    const handleAddSigner = () => {
        const newSigner = {
            name: "",
            birthdate: "",
            document_number: "",
            email: "",
            phone: "",
            document_submission_method: "",
            authentication_submission_method: "",
            document_number_required: true
        }
        const updatedSigners = [...signers, newSigner]
        setSigners(updatedSigners)
    }

    const handleRemoveSigner = (index) => {
        const updatedSigners = [...signers]
        updatedSigners.splice(index, 1)
        setSigners(updatedSigners)
    }

    const [newSignerContact, setNewSignerContact] = useState(undefined)

    const handleCreateContactBySigner = (index) =>{
        const signer = signers[index]
        setNewSignerContact(signer)
        handleContacts()
    }

    const resetNewSignerContactForm = () => {
        setNewSignerContact(undefined)
        setContactGroupSelected(undefined); 
        openContactGroupSelection()
        setOpenContactGroupDialog(false)
        clearSelectedContacts();
        setFilterContactGroupContent("")
    }

    const handleSubmit = async () => {
        if(!userRoles.includes('manage_signers')){
            handleToast('Você não possui permissão para adicionar um assinantes em um envelope', 'error')
            setLoading(false)
            return
        }

        setLoading(true)

        const valid = validateForm()
        if (!valid) {
            handleToast('Existem dados inválidos para criação deste assinante', 'warning')
            setLoading(false)
            return
        }
        
        if((signers || []).length === 0){
            handleToast('É necessário adicionar pelo menos um assinante', 'warning')
            setLoading(false)
            return
        }

        const formattedSigners = signers.map((signer) => {
            const formattedSigner = {
                id :  uuidv4(),
                name: (signer.name).trim(),
                document_submission_method: signer.document_submission_method,
                authentication_submission_method: signer.authentication_submission_method
            }

            if (signer.document_number_required === true) { 
                formattedSigner.document_number = signer.document_number
            }

            if (signer.email !== "") {
                formattedSigner.email = (signer.email).trim()
            }

            if (signer.phone !== "") {
                const digitPhone = signer.phone.replace(/\D/g, '')
                formattedSigner.phone = {
                    international_dial_code: '55',
                    area_code: digitPhone.substring(0, 2),
                    number: digitPhone.substring(2, 11)
                }
            }

            if (signer.birthdate !== ""){
                formattedSigner.birthdate = formatDateToISOZulu(signer.birthdate, 'birthdate')
            }

            if (signer.signature_role && signer.signature_role !== 'others') {
                formattedSigner.signature_role = signer.signature_role
            }
            
            return formattedSigner
        })

        const submissionData = formattedSigners[0]
        
        console.log(envelopeData);
        
        if(!envelopeData?.envelope_key){
            handleToast('Ocorreu um erro ao buscar os dados do envelope ativo', 'warning')
            setLoading(false)
            return
        }

        try {
            await axios.post(`/dash/sign/envelope/${envelopeData.envelope_key}/signer`, submissionData);
            handleToast("success", "Assinante criado com sucesso!")
            resetForm()
            setOpen(false)
            window.location.reload()
        } catch (error) {
            console.error(error);
            handleToast("Ocorreu um erro ao criar assinante", "error");
            setLoading(false);
            return

        } finally {
            setLoading(false)
        }

    }

    const clearSelectedContacts = () => {
        setSelectedContacts([]);
    };

    const handleContactGroupPage = (event, page) => {
        if (currentContactGroupPage === page) {
        return;
        }
        setCurrentContactGroupPage(page);
    };

    const handleContactPage = (event, page) => {
        if (currentContactPage === page) {
        return;
        }
        setCurrentContactPage(page);
    };

    const handleDocumentNumberRequired = (signer_index) => {
        const updatedSigners = signers.map((signer, index) => {
            if (index === signer_index) {
                return {
                    ...signer,
                    document_number_required: !signer.document_number_required,
                    document_number: ""
                };
            }
            return signer;
        });

        setSigners(updatedSigners);
    };

    const userRoles = useContext(AuthContext).user_data.roles
    
    if (loading) {
        return (
            <Dialog open={open} onClose={() => setOpen(false)} >
                <div style={{ width: '400px', padding: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                    <CircularProgress />
                </div>
            </Dialog>
        )
    } else if (error.hasError) {
        return (
            <ErrorPage />
        ) }
    
    else { 

        return (
            <>
                <Dialog 
                onClose={() => {
                    setOpen(false)
                    resetForm()
                }}
                open={open}
                slotProps={{
                    backdrop: {
                    style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
                    }
                }}
                >
                    <div style={{ width: '400px', padding: '2rem' }}>
                        <IconButton
                            aria-label="Close"
                            onClick={() => {
                                setOpen(false)
                                resetForm()
                            }}
                            style={{ float: "right" }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <h2 style={{ marginBottom: '1.5rem' }}>Criação de Assinante</h2>

                        {signers.map((signer, index) => (
                            <div key={index} style={{ border: '1px solid #ccc', padding: '1rem', marginBottom: '1.5rem', borderRadius: '8px' }}>
                                <div>
                                    <LabelInput
                                        labelValue="Nome Completo"
                                        value={signer.name}
                                        onChange={(value) =>
                                            handleInputChange(index, "name", value)
                                        }
                                        onBlur={(value) => handleSignerBlur(index, "name", value)}
                                        error={touched.name && signer.name === ""}
                                        errorMessage={errorMessages.name}
                                    />
                                </div>
                                <div>
                                    <LabelInput
                                        labelValue="Data de Nascimento (Opcional)"
                                        value={signer.birthdate}
                                        placeholder="DD/MM/AAAA"
                                        onChange={(value) =>
                                            handleInputChange(index, "birthdate", value)
                                        }
                                        formatValue={(value) => formatDate(value)}
                                        onBlur={(value) => handleSignerBlur(index, "birthdate", value)}
                                        error={touched.birthdate && !isValidDate(signer.birthdate) && signer.birthdate !== ""}
                                        errorMessage={errorMessages.birthdate}
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', fontSize: "12px", alignItems: 'center', marginBottom: '8px' }}>
                                    <input
                                        type = "checkbox"
                                        checked = {signer.document_number_required}
                                        onChange={() => handleDocumentNumberRequired(index)}
                                        style={{margin: "0 8px 0 0"}}
                                    >    
                                    </input>
                                    <p style = {{margin: "0px"}}>Solicitar CPF ao Assinante</p>
                                </div>
                                {
                                   signer.document_number_required && (
                                        <div>
                                            <LabelInput
                                                labelValue="CPF"
                                                value={signer.document_number}
                                                placeholder="000.000.000-00"
                                                onChange={(value) =>
                                                    handleInputChange(index, "document_number", value)
                                                }
                                                onBlur={(value) => handleSignerBlur(index, "document_number", value)}
                                                formatValue={(value) => formatCPF(value)}
                                                error={(touched.document_number && signer.document_number === "" && signer.document_number_required) ||  (touched.document_number && !isValidCPF(signer.document_number) && signer.document_number_required)}
                                                errorMessage={errorMessages.document_number}
                                            />
                                        </div>
                                    )
                                }
                                <div>
                                    <LabelInput
                                        labelValue="E-mail"
                                        value={signer.email}
                                        onChange={(value) =>
                                            handleInputChange(index, "email", value)
                                        }
                                        onBlur={(value) => handleSignerBlur(index, "email", value)}
                                        error={touched.email && ((signer.document_submission_method === 'email' || signer.authentication_submission_method === 'email') && !isEmail(signer.email))}
                                        errorMessage={errorMessages.email}
                                    />
                                </div>
                                <div>
                                    <LabelInput
                                        labelValue="Telefone (Opcional)"
                                        value={signer.phone}
                                        placeholder="(00) 00000-0000"
                                        onChange={(value) =>
                                            handleInputChange(index, "phone", value)
                                        }
                                        formatValue={(value) => formatPhone(value)}
                                        onBlur={(value) => handleSignerBlur(index, "phone", value)}
                                        error={(touched.phone && !isPhone(signer.phone)) ||
                                        ((signer.document_submission_method === 'sms' || signer.authentication_submission_method === 'sms') && signer.phone === '') ||
                                        ((signer.document_submission_method === 'whatsapp' || signer.authentication_submission_method === 'whatsapp') &&  signer.phone === '') 
                                        }
                                        errorMessage={errorMessages.phone}
                                    />
                                </div>
                                <h3 style={{ marginBottom: '2px' }}>Papel de assinatura:</h3>
                                <SelectInput
                                items={singatureRoleOptions}
                                width="100%"
                                valueKey="value"
                                labelKey="description"
                                onValueChange={(value) => handleInputChange(index, "signature_role", value !== 'others' ? value : undefined)}
                                />
                                <div>
                                    <h3 style={{ marginBottom: '1rem' }}>Método de Envio dos Documentos</h3>
                                    <RadioGroup
                                        row
                                        name="document_submission_method"
                                        value={signer.document_submission_method}
                                        onChange={(event) => handleInputChange(index, "document_submission_method", event.target.value)}
                                    >
                                        <FormControlLabel
                                            value="email"
                                            control={<Radio style={{ color: primaryColor, borderColor: primaryColor }} />}
                                            label="E-mail"
                                        />
                                        <FormControlLabel
                                            value="sms"
                                            control={<Radio style={{ color: primaryColor, borderColor: primaryColor }} />}
                                            label="SMS"
                                        />
                                        <FormControlLabel
                                            value="whatsapp"
                                            control={<Radio style={{ color: primaryColor, borderColor: primaryColor }}/>}
                                            label="WhatsApp"
                                        />
                                    </RadioGroup>
                                    {documentSubmissionErrors[index] && signer.document_submission_method === '' && <p style={{ color: '#B22300' }}>{errorMessages.document_submission_method}</p>}
                                </div>
                                <div>
                                    <h3 style={{ marginBottom: '1rem' }}>Método de Envio da Autenticação</h3>
                                    <RadioGroup
                                        row
                                        name="authentication_submission_method"
                                        value={signer.authentication_submission_method}
                                        onChange={(event) => handleInputChange(index, "authentication_submission_method", event.target.value)}
                                    >
                                        <FormControlLabel
                                            value="email"
                                            control={<Radio style={{ color: primaryColor, borderColor: primaryColor }} />}
                                            label="E-mail"
                                        />
                                        <FormControlLabel
                                            value="sms"
                                            control={<Radio style={{ color: primaryColor, borderColor: primaryColor }}/>}
                                            label="SMS"
                                        />
                                        <FormControlLabel
                                            value="whatsapp"
                                            control={<Radio style={{ color: primaryColor, borderColor: primaryColor }}/>}
                                            label="WhatsApp"
                                        />
                                        {authenticationSubmissionErrors[index] && signer.authentication_submission_method === '' && <p style={{ color: '#B22300' }}>{errorMessages.authentication_submission_method}</p>}
                                    </RadioGroup>
                                </div>
                                <Button
                                    variant="outlined"
                                    startIcon={<RemoveCircleOutlineIcon />}
                                    style={{ width: '100%', margin: '.5rem 0', color: primaryColor, borderColor: primaryColor }}
                                    onClick={() => handleRemoveSigner(index)}
                                >
                                    Remover Assinante
                                </Button>
                                <Button
                                    variant="outlined"
                                    startIcon={<PermContactCalendarIcon />}
                                    style={{ width: '100%', margin: '.5rem 0', color: primaryColor, borderColor: primaryColor }}
                                    onClick={() => handleCreateContactBySigner(index)}
                                >
                                    Salvar assinante na agenda
                                </Button>
                            </div>
                        ))}
                        { signers.length === 0 && 
                            <>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<AddCircleOutlineIcon />}
                                    style={{ width: '100%', margin: '.5rem 0', color: primaryColor, borderColor: primaryColor }}
                                    onClick={handleAddSigner}
                                >
                                    Adicionar Assinante
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<PermContactCalendarIcon />}
                                    style={{ width: '100%', margin: '.5rem 0 1.5rem', color: primaryColor, borderColor: primaryColor }}
                                    onClick={handleContacts}
                                >
                                    Adicionar Assinante da Agenda
                                </Button>
                            </>
                        }

                        <div style={{ alignItems: 'center', textAlign: 'center' }}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleSubmit} 
                                style={{ width: '100%', margin: '1rem 0 0 0', backgroundColor: primaryColor }}
                            >
                                Enviar
                            </Button>
                        </div>
                    </div>
                </Dialog>
                {openDemoRequestModal && (
                    <>
                    <Modal open={openDemoRequestModal} onClose={closeDemoRequestModal}>
                        <Box sx={minorboxStyles}>
                        <S.MinorModalBoxContainer>
                            <ErrorOutlineOutlinedIcon
                            style={{ color: "red", fontSize: 40 }}
                            ></ErrorOutlineOutlinedIcon>
                            <S.InternalDialogContainerDescription>
                            A sua conta atingiu o limite máximo para criação de envelope teste.
                            Faça a ativação do seu plano e continue aproveitando os beneficios do Qi Sign.
                            </S.InternalDialogContainerDescription>
                            <S.MinorModalButtonContainer
                            onClick={() => closeDemoRequestModal()}
                            >
                            <S.ModalButtonDescription>
                                Voltar
                            </S.ModalButtonDescription>
                            </S.MinorModalButtonContainer>
                        </S.MinorModalBoxContainer>
                        </Box>
                    </Modal>
                    </>
                )}
                {openContactGroupDialog && (
                    <Dialog 
                    open={openContactGroupDialog}
                    slotProps={{
                        backdrop: {
                            style: { backgroundColor: 'rgba(0, 0, 0, 0)' }
                        }
                    }} 
                    >
                        <S.ContactGroupContainer>
                            <S.ContactBoxContainer>
                            <div style={{display:"flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 16}}>
                                <div style={{display: "flex", flexDirection: "row", gap: 4, alignItems: "center"}}>
                                    <PermContactCalendarIcon style={{color: "#0b1f82", fontSize: 24 }}></PermContactCalendarIcon>
                                    <h2>Grupos de contato</h2>

                                </div>
                                <IconButton
                                    aria-label="Close"
                                    onClick={() => {
                                        setOpenContactGroupDialog(false)
                                        setContactGroupSelected()
                                        setFilterContactGroupContent("")
                                        setFilterContactContent("")
                                        handleContactGroupSearch("")
                                    }}
                                    style={{ float: "right", height:"24px", width:"24px"}}
                                >
                                <CloseIcon />
                                </IconButton>
                            </div>
                            <SearchBar
                                label="Pesquisar grupo de contatos"
                                content={filterContactGroupContent} 
                                setContent={setFilterContactGroupContent} 
                                refresher={refresherContactGroup} 
                                setRefresher={setRefresherContactGroup}
                                onSearch={handleContactGroupSearch}
                                variable={"name"}
                            />
                            <S.ContactBodyContainer>
                            {contactGroupsData.contact_groups.map((contact_group) => (
                                <S.ContactItem key={contact_group.contact_group}  onClick={() => handleContactGroup(contact_group)}>
                                    <DataField
                                        label="Nome do grupo"
                                        field={contact_group.name}
                                    />
                                    <div className="inbox__cell--right inbox__cell--row-container">
                                            <ContactsIcon
                                                style={{ height: "16px", width: "16px" }}
                                                id={contact_group.contact_group_key}
                                            />
                                    </div>
                                </S.ContactItem>
                            ))}
                            </S.ContactBodyContainer>
                            <S.ContactPaginationContainer lock="true">
                                <Pagination
                                    page={currentContactGroupPage}
                                    count={maxContactGroupPage}
                                    onChange={(event, page) => handleContactGroupPage(event, page)}
                                />
                            </S.ContactPaginationContainer>
                        </S.ContactBoxContainer>
                        </S.ContactGroupContainer>
                    </Dialog>
                )}
                {openContactSelectionDialog && contactsData && (
                    <Dialog 
                    open={openContactSelectionDialog} 
                    onClose={() => setOpenContactSelectionDialog(false)}
                    slotProps={{
                        backdrop: {
                        style: { backgroundColor: 'rgba(0, 0, 0, 0)' }
                        }
                    }} 
                    >
                        <S.ContactGroupContainer>
                        {contactsLoading ? (
                            <S.LoadingContainer>
                                <CircularProgress />
                            </S.LoadingContainer>
                            ):(
                                <S.ContactBoxContainer>
                                    <div style={{display:"flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 16}}>
                                        <div style={{display: "flex", flexDirection: "row", gap: 4, alignItems: "center"}}>
                                            <PermContactCalendarIcon style={{color: "#0b1f82", fontSize: 24 }}></PermContactCalendarIcon>
                                            <h2>Lista de contatos</h2>

                                        </div>
                                        <IconButton
                                            aria-label="Close"
                                            onClick={() => {
                                                setOpenContactSelectionDialog(false);
                                                setContactGroupSelected(undefined); 
                                                clearSelectedContacts();
                                                setFilterContactContent("")
                                                setFilterContactGroupContent("")
                                            }}
                                            style={{ float: "right", height:"24px", width:"24px"}}
                                        >
                                        <CloseIcon />
                                        </IconButton>
                                    </div>
                                    <SearchBar
                                        label="Pesquisar contato"
                                        content={filterContactContent} 
                                        setContent={setFilterContactContent} 
                                        refresher={refresherContact} 
                                        setRefresher={setRefresherContact}
                                        onSearch={handleContactSearch}
                                        variable={"contact_name"}
                                    />
                                <S.ContactBodyContainer style={{height: "260px"}}>
                                {contactsData.contacts && contactsData.contacts.map((contact) => (
                                    <S.ContactItem key={contact.contact_key} onClick={() => handleCheckboxChange(contact)}>
                                        <Checkbox
                                            checked={verifyContactOnCheckbox(contact.contact_key)}
                                            onChange={() => {}}
                                        />
                                        <div className="data-field">
                                            <span className="data-field__value">{contact.contact_name}</span>
                                            {contact?.contact_data?.details && 
                                            <div style={{marginTop:'5px'}}>
                                                {<span className="data-field__label">{contact?.contact_data?.details}</span>}
                                            </div>
                                            }
                                        </div>
                                    </S.ContactItem>
                                ))}
                                </S.ContactBodyContainer>                            
                                <S.ContactPaginationContainer style={{width: "340px"}}>
                                    <Pagination
                                        page={currentContactPage}
                                        count={maxContactPage}
                                        onChange={(event, page) => handleContactPage(event, page)}
                                    />
                                </S.ContactPaginationContainer>
                                <div style={{padding:"0 20px"}}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            handleContactsSelect();
                                            setOpenContactSelectionDialog(false);
                                            setOpenContactGroupDialog(false);
                                        }}
                                        style={{ width: '100%', margin: '24px 0', backgroundColor: primaryColor }}
                                    >
                                    Selecionar
                                    </Button>


                                </div>
                            </S.ContactBoxContainer>
                            )
                        }
                        </S.ContactGroupContainer>
                    </Dialog>
                )}
            </>
        )
    }
};

export default SignerCreationDialog;